import { Component, OnInit } from '@angular/core';

import {Material} from "../shared/material.model";
import {materialTitle, materialCodigoMask} from "../shared/data.service";
import {MaterialService} from "../shared/material.service";
import {UtilService} from "../../../../shared/services/util.service";

declare var swal: any;

@Component({
    template: require('./material-list.component.html')
})

export class MaterialListComponent implements OnInit {
    materialTitle: any = materialTitle;
    list: Array<Material> = [];
    showDisabled: boolean = false;
    showLoad: boolean = true;
    materialCodigoMask: number = materialCodigoMask;

    constructor(
        private _service: MaterialService,
        private _utilService: UtilService
    ){}

    ngOnInit() {
        var onDone = (function(Response: any) {
            if (!Response.error) {
                var items: Array<Material> = Response;

                items.forEach(function(item: any) {
                    if (item.grupoMaterial) {
                        item.subgrupo = this._utilService.cloneObject(item.grupoMaterial);
                        item.grupo = item.subgrupo.grupo;
                    }
                    item.classificacao = this._service.getClassificacao(item);
                }.bind(this));

                this.list = items;
            } else {
                this._utilService.swalMessageWarningCustom(Response.error);
            }
            this.showLoad = false;
        }.bind(this));

        this._service.onGetAll(onDone);
    }

    onclickGoToAdd() {
        this._service.clearStorage();
        this._service.goToAdd();
    }

    onclickDelete(item: any) {
        swal({
                title: "Você deseja realmente excluir este item?",
                text: "O item será desativado.",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Sim, Excluir",
                cancelButtonText: "Cancelar",
                closeOnConfirm: false
            },
            function() {
                this.onDelete(item);
            }.bind(this)
        );
    }

    onclickGoToEdit(item: any) {
        this._service.clearStorage();

        this._service.setStorage(item);
        this._service.goToEdit(item.id);
    }

    onclickGoToDetail(item: any) {
        this._service.setStorage(item);
        this._service.goToDetail(item.id);
    }

    private onDelete(item: any) {
        var onDone = (function(Response: any) {
            if (!Response.error) {
                var x: number, lenX: number;
                for (x = 0, lenX = this.list.length; x < lenX; x++) {
                    if (this.list[x].id === item.id) {
                        this.list[x].ativo = false;
                        break;
                    }
                }
                swal("Excluído!", this.deleteSuccess, "success");
            } else {
                swal("Erro!", this.deleteError, "error");
            }
        }.bind(this));

        this._service.onDelete(item.id, onDone);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/materiais/material/material-list/material-list.component.ts
 **/